module.exports = __webpack_public_path__ + "img/20180815_151844_202.1a430e21.jpg";